import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Radium from 'radium'
import { translate } from 'react-i18next'

/* Utilities */
import _ from 'lodash'

/* Widgets */
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Actions */
import { fetchCameraImage, fetchGraphicsOutput } from 'react-redux/actions/media-player'
import { hideModal } from 'react-redux/actions/modal'

/* Styles */
import './snapshot.css'

/* Component to monitor online edge devices */
class MediaPlayerSnapshot extends Component {

  constructor(props) {
    super(props)
    this.state = {
      beamerConnected: true,
      parentWidth: 0,
      parentHeight: 0,
      mediaWidth: 0,
      mediaHeight: 0,
    }
  }

  componentDidMount() {
    var node = ReactDOM.findDOMNode(this)
    node.focus()
    this.keyDownListener = this.onKeyDown.bind(this)
    this.resizeListener = this.onResize.bind(this)
    window.addEventListener('keydown', this.keyDownListener)
    window.addEventListener('resize', this.resizeListener)
    this.onResize()
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keyDownListener)
    window.removeEventListener("resize", this.resizeListener)
  }

  onResize(e) {
    this.setState({
      parentWidth: this.root.parentNode.offsetWidth,
      parentHeight: this.root.parentNode.offsetHeight
    })
  }

  onKeyDown(e) {
    switch (e.keyCode) {
      case 27: // esc
        e.preventDefault()
        e.stopPropagation()
        this.cancel()
        break
    }
  }

  onImageLoad(e) {
    this.setState({
      mediaWidth: e.target.naturalWidth,
      mediaHeight: e.target.naturalHeight
    })
    this.guessIfBeamerConnected()
  }

  cancel() {
    const { hideModal } = this.props
    hideModal()
  }

  /* Takes a photo using the camera of the selected edge */
  makeCameraSnapshot() {
    const { fetchCameraImage, uid } = this.props
    fetchCameraImage(uid)
  }

  /* Takes a screenshot of the display output */
  makeGraphicsOutputSnapshot() {
    const { fetchGraphicsOutput, uid } = this.props
    fetchGraphicsOutput(uid)
  }

  /* Guess if Beamer is connected by interpreting img size. Quite a hack */
  guessIfBeamerConnected() {
    if (
      this.imgRef
      && this.imgRef.naturalWidth <= 64
      && this.imgRef.naturalHeight <= 64
      && this.state.beamerConnected
    ) {
      this.setState({beamerConnected: false})
    } else if (!this.state.beamerConnected) {
      this.setState({beamerConnected: true})
    }
  }

  renderWarning() {
    if (!this.state.beamerConnected) {
      return (
        <div className="warnig-overlay">
          <Icon
            icon={ ICON.GRAPHICS_OUTPUT }
            title={ ""}
            size={ 72 }
            circle={ true }
            scheme={ ICON_SCHEME.DANGER }
            interactive={ false }
          />
        </div>
      )
    }
    return null
  }

  getTitle() {
    const { t, type } = this.props
    if(type == 0) return t("mediaplayer:snapshot.grahicsOutputTitle")
    if(type == 1) return t("mediaplayer:snapshot.cameraTitle")
  }

  /* former cancel button */
  render() {
    const { t, image, type } = this.props
    const {
      parentWidth,
      parentHeight,
      mediaWidth,
      mediaHeight
    } = this.state
    // Calculating maximum dimensions of media content
    const maxHeight = Math.min(parentHeight-164, parentHeight * .8)
    const maxWidth = Math.min(parentWidth-48, parentWidth * .8)
    const scale = Math.min(
      1, // never upscale
      Math.min(maxWidth/mediaWidth, maxHeight/mediaHeight)
    )
    return (
      <div
        className='media-player-snapshot component modal-frame'
        ref={ (ref) => { this.root = ref } }
      >
        <h2 className="modal-title">{ this.getTitle() }</h2>
        <div className="modal-body"><img
          src={ image }
          ref={ (ref) => { this.imgRef = ref} }
          width={ mediaWidth * scale }
          height={ mediaHeight * scale }
          onLoad={ this.onImageLoad.bind(this) }
        />{ this.renderWarning() }<div
          className="snapshot-controls"
        >
            <button
              className="action"
              title={ t("mediaplayer:snapshot.cameraButtonTitle") }
              onClick={ this.makeCameraSnapshot.bind(this) }>
              { t("mediaplayer:snapshot.cameraButtonLabel") }
            </button>
            <button
              className="action"
              title={ t("mediaplayer:snapshot.graphicsOutputButtonTitle") }
              onClick={ this.makeGraphicsOutputSnapshot.bind(this) }>
              { t("mediaplayer:snapshot.graphicsOutputButtonLabel") }
            </button>
          </div>
        </div>
      </div>
    )
  }
}

MediaPlayerSnapshot.propTypes = {}

function mapStateToProps(state) {
  return Object.assign(
    {},
    state.mediaPlayer.snapshot
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchCameraImage,
      fetchGraphicsOutput,
      hideModal,
    },
    dispatch
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaPlayerSnapshot)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default Radium(translatedComponent)



// WEBPACK FOOTER //
// ./src/app/component/media-player/snapshot.jsx